<!-- <div style="overflow: hidden" *ngIf="!isExecutiveRoute" class="content" role="main"> -->
<div *ngIf="!isExecutiveRoute" class="content" role="main">
  <div class="card-container">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-container *ngIf="isExecutiveRoute">
  <app-executive-top-nav class="w-100" *ngIf="!isFullPageView"></app-executive-top-nav>

  <div class="app-content" [ngClass]="{'fill-page': false}">
    <div class="dark-overlay" *ngIf="isSideNavOpen" (click)="closeSideBar()"></div>



    <app-executive-side-nav class="app-side-nav" [ngClass]="{'hidden': !isSideNavOpen}"
      *ngIf="!isFullPageView"></app-executive-side-nav>

    <div class="outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

<!-- <app-taxpayer-record-update-notification></app-taxpayer-record-update-notification> -->